import React from 'react'
import PlayerCreated from '../player-created'
import PlayerCreatedMatches from '@commons/matches/player-created'

const AwaitingResults = () => {
  return (
    <>
      <PlayerCreatedMatches matchStatus="Review" isResult={true} />
    </>
  )
}

export default AwaitingResults
